module.exports = __webpack_public_path__ + "img/oowakudani.9a5257bd.jpg";